"use client";

import { cn } from "@/lib/utils";

/** Lớp trang trí header / sidebar — bảng xanh + hoa hồng 20/11, không chặn tương tác. */
export function TeachersDayHeaderDecor({ className }: { className?: string }) {
  return (
    <div className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)} aria-hidden>
      <style>{`
        @keyframes td-dust {
          0% { transform: translateY(6px); opacity: 0; }
          30% { opacity: 0.65; }
          100% { transform: translateY(-28px); opacity: 0; }
        }
        @keyframes td-sway {
          0%, 100% { transform: rotate(-6deg); }
          50% { transform: rotate(7deg); }
        }
        .td-dust { animation: td-dust 3.8s ease-in infinite; }
        .td-sway { animation: td-sway 5s ease-in-out infinite; transform-origin: 50% 90%; }
      `}</style>

      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_8%_0%,rgba(16,185,129,0.22),transparent_52%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_92%_0%,rgba(244,63,94,0.14),transparent_48%)]" />
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(0deg, transparent, transparent 11px, rgba(255,255,255,0.35) 12px)",
        }}
      />

      <div className="absolute -left-6 top-1/2 h-20 w-20 -translate-y-1/2 rounded-full bg-emerald-400/15 blur-2xl" />
      <div className="absolute -right-4 top-0 h-16 w-16 rounded-full bg-rose-400/12 blur-2xl" />

      {/* chalk dust */}
      {[10, 28, 48, 70, 86].map((left, i) => (
        <span
          key={left}
          className="td-dust absolute bottom-1 rounded-full bg-emerald-100/60"
          style={{
            left: `${left}%`,
            width: 2 + (i % 2),
            height: 2 + (i % 2),
            animationDelay: `${i * 0.55}s`,
          }}
        />
      ))}

      {/* rose */}
      <svg
        className="td-sway absolute left-[6%] top-1.5 hidden h-8 w-8 text-rose-400/40 sm:block"
        viewBox="0 0 40 40"
        fill="currentColor"
      >
        <path d="M20 5c3 5 2 9-1 12 4-1 8 2 9 6-4-1-8 1-10 4 1-4-1-8-5-10 3 0 5-4 7-12z" />
        <circle cx="20" cy="20" r="2" opacity=".5" />
      </svg>

      {/* book mark */}
      <svg
        className="absolute right-[7%] top-2 hidden h-7 w-7 text-emerald-300/35 md:block"
        viewBox="0 0 40 40"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
      >
        <path d="M8 8h10c3 0 5 2 5 5v19c0-2.5-2-4-5-4H8V8z" />
        <path d="M32 8H22c-3 0-5 2-5 5v19c0-2.5 2-4 5-4h10V8z" />
        <path d="M18 13h4" opacity=".6" />
      </svg>

      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-emerald-400/50 to-transparent" />
    </div>
  );
}

export function TeachersDaySeasonBadge({ compact, className }: { compact?: boolean; className?: string }) {
  if (compact) {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1.5 rounded-md border border-emerald-400/35 bg-gradient-to-r from-emerald-500/15 to-rose-500/10 px-2 py-0.5 text-[10px] font-bold text-emerald-100",
          className
        )}
      >
        <span className="tabular-nums text-rose-200">20.11</span>
        <span className="text-emerald-200/80">Nhà Giáo</span>
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md border border-emerald-400/35 bg-gradient-to-r from-emerald-500/20 to-rose-500/15 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-emerald-100",
        className
      )}
    >
      Ngày Nhà Giáo Việt Nam
    </span>
  );
}
